import { render } from "./messageSummary.vue?vue&type=template&id=30b66737"
import script from "./messageSummary.vue?vue&type=script&lang=js"
export * from "./messageSummary.vue?vue&type=script&lang=js"

import "./messageSummary.vue?vue&type=style&index=0&id=30b66737&lang=css"

import exportComponent from "C:\\Users\\david\\Desktop\\Netloud\\whiteLabel\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__